import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/user.png'
import _imports_1 from '../assets/image/icon/customer_service.png'


const _withScopeId = n => (_pushScopeId("data-v-15fd6abd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-view" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = { class: "header-nav" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "nav-sub"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-global" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "lang-icon" }),
  /*#__PURE__*/_createElementVNode("span", { class: "lang-text" }, "CN"),
  /*#__PURE__*/_createElementVNode("div", { class: "lang-arrow" })
], -1))
const _hoisted_8 = {
  key: 0,
  class: "header-operate"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "header-avatar"
}, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "header-operate"
}
const _hoisted_11 = { class: "layout-content" }
const _hoisted_12 = { class: "operate-box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "customer-service"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

import { computed, ref, unref, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router";
import LoginModal from "../components/LoginModal.vue";
import LayoutFooter from "../layout/LayoutFooter.vue";
import { getToken } from "@/common/storage";

interface Nav {
  title: string;
  routeName: string;
  subList?: Nav[];
  link?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutView',
  setup(__props) {

const navList = ref<Nav[]>([
  { title: "首页", routeName: "Homepage" },
  { title: "申报审批", routeName: "Apply" },
  { title: "办会原则", routeName: "Principle" },
  { title: "全链路解决方案", routeName: "Solution" },
  { title: "“遇”杭州", routeName: "Information" },
  { title: "关于我们", routeName: "Mine" },
]);

const router = useRouter();
const route = useRoute();
const isMy = computed(() => route.name == "My");
const active = computed(() =>
  navList.value.findIndex((n) => n.routeName === route.name)
);
// const blueList = ["Approval", "Apply", "Solution", "Information", "Mine"];
// const is_blue = computed(() => blueList.includes(route.name as string));

const visible = ref<boolean>(false);
const has_register = !!getToken();
const register = () => {
  router.push({ name: "Login", query: { r: location.pathname } });
};
const goMy = () => {
  router.push({ name: "My" });
};

const jump = (nav: Nav) => {
  router.push({ name: nav.routeName });
};
const jumpSub = (sub: Nav) => {
  router.push({ name: sub.routeName, query: { link: sub.link } });
};
watchEffect(() => {
  const name = route.name;
  const index = unref(navList).findIndex((item: Nav) => item.routeName == name);
  if (index > -1) {
    active.value = index;
  }
});
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
const showTop = ref(false);
window.onscroll = function () {
  var currentHeight =
    document.documentElement.scrollTop ||
    window.pageYOffset ||
    document.body.scrollTop;
  // 页面滚动超过300px就显示
  if (currentHeight > 600) {
    showTop.value = true;
  } else {
    showTop.value = false;
  }
};

const handleService = () => {
  console.log("handleService");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["layout-header center-content", { 'layout-header-black': isMy.value }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: { name: 'Homepage' },
            class: "header-logo"
          }),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, (nav, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: nav.routeName,
                class: _normalizeClass(["nav-item", { active: index == active.value }]),
                onClick: ($event: any) => (jump(nav))
              }, [
                _createTextVNode(_toDisplayString(nav.title) + " ", 1),
                (nav.subList)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nav.subList, (sub) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "nab-sub-item",
                          key: sub.routeName,
                          onClick: _withModifiers(($event: any) => (jumpSub(sub)), ["stop"])
                        }, _toDisplayString(sub.title), 9, _hoisted_6))
                      }), 128))
                    ], 512)), [
                      [_vShow, index == 1]
                    ])
                  : _createCommentVNode("", true)
              ], 10, _hoisted_4))
            }), 128))
          ]),
          _hoisted_7,
          has_register
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: "login-btn",
                  onClick: goMy
                }, [
                  _hoisted_9,
                  _createTextVNode(" 我的 ")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "login-btn",
                  onClick: register
                }, "登陆"),
                _createElementVNode("div", {
                  class: "login-btn",
                  onClick: register
                }, "注册")
              ]))
        ])
      ], 2),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(LayoutFooter, {
        navs: navList.value.slice(1)
      }, null, 8, ["navs"]),
      _createElementVNode("div", _hoisted_12, [
        (showTop.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "operate-item to-top",
              onClick: scrollToTop
            }, " 顶 部 "))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "operate-item",
              onClick: handleService
            }, _hoisted_14))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(LoginModal, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event))
    }, null, 8, ["visible"])
  ], 64))
}
}

})